import { create } from "zustand";

export type ModalType = "terms" | "confirm" | "alert";

type ModalItem = { id: string; type: ModalType };

type ModalState = {
  modals: ModalItem[];
  open: (type: ModalType) => string;
  close: (id: string) => void;
  closeTop: () => void;
  closeAll: () => void;
};

const makeId = () => `${Date.now()}-${Math.random().toString(16).slice(2)}`;

export const useModalStore = create<ModalState>((set, get) => ({
  modals: [],
  open: (type) => {
    const id = makeId();
    set((s) => ({ modals: [...s.modals, { id, type }] }));
    return id;
  },
  close: (id) => set((s) => ({ modals: s.modals.filter((m) => m.id !== id) })),
  closeTop: () => {
    const { modals } = get();
    if (modals.length === 0) return;
    const topId = modals[modals.length - 1].id;
    set((s) => ({ modals: s.modals.filter((m) => m.id !== topId) }));
  },
  closeAll: () => set({ modals: [] }),
}));
